import { render } from "./calenderApp.vue?vue&type=template&id=0661345a"
import script from "./calenderApp.vue?vue&type=script&lang=js"
export * from "./calenderApp.vue?vue&type=script&lang=js"

import "./calenderApp.vue?vue&type=style&index=0&id=0661345a&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__